var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 24c4.418 0 8-3.581 8-8s-3.582-8-8-8-8 3.581-8 8 3.582 8 8 8m4.002-10.024-5.227 5.228L12 16.428l1.118-1.118 1.658 1.65 4.109-4.102z",
  clipRule: "evenodd"
})));
export default SvgCheckCircle;